export default "/fonts/vendor/katex/dist/KaTeX_Size2-Regular.woff2?2960900c4f271311eb36d175a209aa0a";